/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Last_DayInputs */

const en_us2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Last day`)
};

const pt_br2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último dia`)
};

const es_419_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último día`)
};

const pt_pt2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Último dia`)
};

const fr_fr2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dernier jour`)
};

const de_de2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letzter Tag`)
};

const it_it2_clubs_last_day = /** @type {(inputs: Clubs_Last_DayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ultimo giorno`)
};

/**
* | output |
* | --- |
* | "Last day" |
*
* @param {Clubs_Last_DayInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_last_day = /** @type {((inputs?: Clubs_Last_DayInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Last_DayInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_last_day(inputs)
	if (locale === "es-419") return es_419_clubs_last_day(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_last_day(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_last_day(inputs)
	if (locale === "de-DE") return de_de2_clubs_last_day(inputs)
	if (locale === "it-IT") return it_it2_clubs_last_day(inputs)
	return en_us2_clubs_last_day(inputs)
});
export { clubs_last_day as "clubs.last_day" }